// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__26Qnt","title":"Advt_title__74uiT","qrBlock":"Advt_qrBlock__9PrDB","qrCode":"Advt_qrCode__15sJN"};